import {
  bidFileTypeDict,
  kpbProjectStatusDict,
  reviewModelDict
} from '@/dictionary/project/kpb-project'
import {
  fileSubmitStatusDict,
  quoteFileStatusDict,
  quoteOpenStatusDict
} from '@/dictionary/hall/open-bid-hall'

/**
 * 获取供应商开标步骤
 */
const getOpenStep = (kpbProject, bidderInfo) => {
  const timeInfo = kpbProject.timeInfo || {}
  // 是否是双信封
  const isDouble =
    kpbProject.projectInfo?.reviewModel === reviewModelDict.DOUBLE.value
  // 商务文件已被退回
  const supplierFileWithdraw =
    bidderInfo.bidFileStatus === fileSubmitStatusDict.RETURNED.value
  // 项目开标节点
  const decryptStep = {
    title: supplierFileWithdraw ? '文件退回' : '文件解密',
    status: 1,
    time: bidderInfo.decryptTime,
    component: 'OpenDecode',
    bidFileType: bidFileTypeDict.BUSINESS.value
  }
  // 开标一览表节点
  const endStep = {
    title: '开标结束',
    status: 0,
    time: timeInfo.openEndTime,
    component: 'BidOpenMark',
    bidFileType: bidFileTypeDict.BUSINESS.value
  }
  const defaultStepList = []
  if (supplierFileWithdraw) {
    decryptStep.status = 2
    defaultStepList.push(decryptStep)
  } else {
    const { OPEN_MARK, OPEN_BID_ENDED } = kpbProjectStatusDict

    if (kpbProject.projectStatus >= OPEN_MARK.value) {
      decryptStep.status = 2
      endStep.status = supplierFileWithdraw ? 2 : 0
    }
    // 如果已结束开标，则第二步为已完成
    if (kpbProject.projectStatus >= OPEN_BID_ENDED.value) {
      decryptStep.status = 2
      endStep.status = 2
    }
    defaultStepList.push(...[decryptStep, endStep])
  }

  // 如果是双信封，则需要增加报价开标步骤
  if (isDouble) {
    endStep.title = '一阶段开标结果'
    const quoteStepList = getQuoteOpenStepList(kpbProject, bidderInfo)
    defaultStepList.push(...quoteStepList)
  }
  return defaultStepList
}

/**
 * 获取报价文件开标步骤
 */
const getQuoteOpenStepList = (kpbProject, bidderInfo) => {
  const timeInfo = kpbProject.timeInfo || {}
  // 报价文件已被退回
  const quoteFileWithdraw =
    bidderInfo.offerBidFileStatus === quoteFileStatusDict.RETURNED.value
  // 报价文件解密
  const quoteDecryptStep = {
    title: '报价文件解密',
    status: 0,
    time: bidderInfo.offerDecryptTime,
    component: 'OpenDecode',
    bidFileType: bidFileTypeDict.QUOTATION.value
  }
  // 报价开标结束（报价开标一览表）
  const quoteDecryptEndStep = {
    title: '二阶段开标结果',
    status: 0,
    time: timeInfo.offerOpenEndTime,
    component: 'QuoteOpenMark',
    bidFileType: bidFileTypeDict.QUOTATION.value
  }
  // 如果报价文件被退回，则无结果
  if (quoteFileWithdraw) {
    quoteDecryptStep.status = 2
    return [quoteDecryptStep]
  }
  // 如果等待开标，则第一步为进行中
  if (kpbProject.offerBidOpenStatus === quoteOpenStatusDict.PENDING.value) {
    quoteDecryptStep.status = 1
  }
  // 如果已开启报价，则第一步为进行中
  if (kpbProject.offerBidOpenStatus === quoteOpenStatusDict.IN.value) {
    quoteDecryptStep.status = 1
  }
  // 如果已唱标，则第一步已完成，第二部进行中
  if (kpbProject.offerBidOpenStatus === quoteOpenStatusDict.OPEN_MARK.value) {
    quoteDecryptStep.status = 2
  }
  // 如果已结束开标，则第二步为已完成
  if (kpbProject.offerBidOpenStatus >= quoteOpenStatusDict.END.value) {
    quoteDecryptStep.status = 2
    quoteDecryptEndStep.status = quoteFileWithdraw ? 0 : 2
  }
  return [quoteDecryptStep, quoteDecryptEndStep]
}

/**
 * 找到默认进入的步骤
 */
const getDefaultStepIndex = stepList => {
  console.log('stepList', stepList)
  // 找到第一个进行中的步骤下标
  let currentIndex = stepList.findIndex(item => item.status === 1)
  if (currentIndex < 0) {
    // 如果没有进行中，则找到最后一个已完成的步骤下标
    currentIndex =
      stepList.length -
      stepList.toReversed().findIndex(item => item.status === 2) -
      1
  }
  return currentIndex
}

const useSupplierOpenStep = () => {
  return {
    getOpenStep,
    getDefaultStepIndex
  }
}

export default useSupplierOpenStep
